function formatarMoeda(texto) {
    var valor = parseFloat(texto) || 0;
    var formatado = (valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    return formatado;
}

export default formatarMoeda;